import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/login");
      return;
    }

    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        // Clean hash
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/dashboard", { state: { user: data.user } });
      } catch (e) {
        if (process.env.NODE_ENV !== "production") {
          // eslint-disable-next-line no-console
          console.warn("auth callback failed:", e?.message);
        }
        navigate("/login");
      }
    })();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-lokaso-sand" data-testid="auth-callback-loading">
      <div className="text-center">
        <div className="lokaso-flag-stripe inline-flex h-8 mb-3"><span /><span /><span /></div>
        <p className="font-display text-xl text-lokaso-green">Connexion en cours…</p>
      </div>
    </div>
  );
}
